var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__donate"},[_c('img',{staticClass:"message__image",attrs:{"src":`${_vm.myUrl}/source/images/icons/gifts/coin-flip-43.gif`,"alt":"donate","width":"130","height":"130"}}),_vm._v(" "),_c('span',{staticClass:"message__title"},[_vm._v(_vm._s(_vm.getAmount()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }